export enum Materials {
    Original = 'Original',
    Matte = 'Matte',
    Fusion = 'Fusion',
    StyleSkins = 'Style Skins',
    Pruvia = 'Pruvia',
    CurvedFusion = 'Curved Fusion',
    Privacy = 'Privacy',
    FusionPro = 'Fusion Pro',
}

export const MaterialMap = {
    [Materials.Original]: 1,
    [Materials.Matte]: 2,
    [Materials.Fusion]: 3,
    [Materials.StyleSkins]: 4,
    [Materials.Pruvia]: 6,
    [Materials.CurvedFusion]: 7,
    [Materials.Privacy]: 8,
    [Materials.FusionPro]: 9,
} as const;

export const OffsetMaterials = {
    [Materials.Original]: 1,
    [Materials.Matte]: 2,
    [Materials.StyleSkins]: 4,
    [Materials.Fusion]: 7,
    [Materials.Privacy]: 8,
    [Materials.FusionPro]: 9,
};

export const MaterialIdMap = {
    1: [Materials.Original],
    2: [Materials.Matte],
    3: [Materials.Fusion],
    4: [Materials.StyleSkins],
    6: [Materials.Pruvia],
    7: [Materials.CurvedFusion],
    8: [Materials.Privacy],
    9: [Materials.FusionPro],
};

